export const showDateRangeSelector = (path) => {
  const pathsWithDateRangeSelector = [
    // Portfolio paths with energyGroupId
    /portfolio\/(power|heat|water)\/\d+\/energy-breakdown/,
    /portfolio\/(power|heat|water)\/\d+\/energy-breakdown-table/,
    /portfolio\/(power|heat|water)\/\d+\/child-analysis/,
    /portfolio\/(power|heat|water)\/\d+\/hour-analysis/,
    /portfolio\/(power|heat|water)\/\d+\/duration-analysis/,
    /portfolio\/(power|heat|water)\/\d+\/energy-analysis/,
    /portfolio\/(power|heat|water)\/\d+\/comparison-analysis/,
    /portfolio\/(power|heat|water)\/\d+\/load-profile-analysis/,
    /portfolio\/(power|heat|water)\/\d+\/esg/,

    // Energyxplorer paths with energyGroupId
    /deepdive\/\d+\/consumption-overview/,
    /deepdive\/\d+\/energy-breakdown/,
    /deepdive\/\d+\/energy-breakdown-table/,
    /deepdive\/\d+\/energy-initiatives/,
    /deepdive\/\d+\/esg/,
    /deepdive\/\d+\/*/,
    /deepdive\/\d+$/,
  ];

  // Remove leading slash and query params for comparison
  const cleanPath = path.replace(/^\//, '').split('?')[0];

  return pathsWithDateRangeSelector.some((pattern) => pattern.test(cleanPath));
};

export const showEnergyGroupSettings = (path) => {
  const pathsWithEnergyGroupSettings = [
    // Energyxplorer paths with energyGroupId
    /deepdive\/\d+\/consumption-overview/,
    /deepdive\/\d+\/energy-breakdown/,
    /deepdive\/\d+\/energy-breakdown-table/,
    /deepdive\/\d+\/energy-initiatives/,
    /deepdive\/\d+\/esg/,
    /deepdive\/\d+\/*/,
    /deepdive\/\d+$/,
  ];

  // Remove leading slash and query params for comparison
  const cleanPath = path.replace(/^\//, '').split('?')[0];

  return pathsWithEnergyGroupSettings.some((pattern) =>
    pattern.test(cleanPath),
  );
};

export const showMissingPortfolioGroupAlert = (viewType) => {
  return (
    viewType === 'powerPortfolio' ||
    viewType === 'heatPortfolio' ||
    viewType === 'waterPortfolio'
  );
};
